import React from "react";
import "./EnginePicker.css";

/**
 * EnginePicker — EIN Engine-/Pipeline-Picker für alle Seiten (Welle 80).
 *
 * Ingvars Vorgabe: „ein Button = ein Unterprogramm“ — Dokumente verschieben,
 * Zählerstände und Fotos nutzen dieselbe Komponente und übergeben nur die
 * Optionen als Parameter.
 *
 * <EnginePicker
 *   file={{ name, alle?: bool, anzahl?: number }}   // was analysiert wird
 *   title="Analyse-Engine wählen"
 *   subtitle="…"                                      // optional, sonst aus file
 *   options={[{ key, label, desc, accent?: "v1"|"v2"|"v3"|"cache", disabled?, title?, badge? }]}
 *   extra={<…/>}                                      // optionaler Slot (z.B. Schema-Select)
 *   onChoose={(key) => …}
 *   onClose={() => …}
 * />
 */
export default function EnginePicker({ file, title, subtitle, options, extra, onChoose, onClose }) {
  if (!file) return null;
  const sub = subtitle
    || (file.alle
      ? `${file.anzahl != null ? file.anzahl : "Alle"} Datei${file.anzahl === 1 ? "" : "en"} neu analysieren mit:`
      : `📷 ${file.name || String(file.path || "").split("/").pop()}`);
  return (
    <div className="v-pipeline-overlay" onClick={onClose}>
      <div className="v-pipeline-modal ep-modal" onClick={(e) => e.stopPropagation()}>
        <h3>{title || "Analyse-Engine wählen"}</h3>
        <p className="v-pipeline-subtitle">{sub}</p>
        <div className="v-pipeline-options ep-options">
          {(options || []).map((o) => (
            <button
              key={o.key}
              className={`v-pipeline-btn v-pipeline-${o.accent || "v1"}`}
              disabled={!!o.disabled}
              title={o.title || undefined}
              onClick={() => { onClose && onClose(); onChoose && onChoose(o.key); }}
            >
              {o.badge && <span className="v-pipeline-badge">{o.badge}</span>}
              <span className="v-pipeline-label">{o.label}</span>
              {o.desc && <span className="v-pipeline-desc">{o.desc}</span>}
            </button>
          ))}
        </div>
        {extra}
        <button className="v-pipeline-cancel" onClick={onClose}>Abbrechen</button>
      </div>
    </div>
  );
}
